/* eslint-disable */

export const GRAPHQL_URI = process.env.REACT_APP_GRAPHQL_URI;
export const NODE_ENV = process.env.NODE_ENV;
export const AZURE_AUTHORITY_URL = process.env.REACT_APP_AZURE_AUTHORITY_URL;
export const AZURE_CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID;
export const MAP_URL = process.env.REACT_APP_MAP_URL;
